<template>
  <p class="clearfix mb-0">
    <span class="float-md-left d-block d-md-inline-block mt-25">
      COPYRIGHT  © {{ new Date().getFullYear() }}
      <b-link
        class="ml-25"
        href="http://www.iconext.co.th"
        target="_blank"
      >iCONEXT Co., Ltd</b-link>
      <span class="d-none d-sm-inline-block">, All rights Reserved</span>
      <span class="d-none d-sm-inline-block">, Build 20221213</span>
    </span>
  </p>
</template>

<script>
import { BLink } from 'bootstrap-vue'

export default {
  components: {
    BLink,
  },
}
</script>
